module.exports = __webpack_public_path__ + "static/media/Roboto-Thin.321de678.ttf";